<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Boolean,
            default: null,
        },
    },
};
</script>

<template>
    <span :class="value ? 'text-info' : 'text-danger'">
        <i :class="`fa fa-fw fa-${value ? 'check' : 'times'}`" /> {{ value ? 'Yes' : 'No' }}
    </span>
</template>

<style
    scoped
    lang="scss"
>

</style>
